export class IDNameDescriptionItem {
    id?: number | string;
    name?: string;
    description?: string;
    active?: boolean;

}

export class IDNameDescriptionDictionary {
    [key: string]: IDNameDescriptionItem
}

export function getNameByIdInIDNameDescriptionDictionary(dict: IDNameDescriptionDictionary, id: string | number) {
    return dict[id]?.name ?? null;
}

export const filterIDNameDescriptionDictionary = (
    dictionary: IDNameDescriptionDictionary,
    filterCondition: (item: IDNameDescriptionItem) => boolean
): IDNameDescriptionDictionary => {
    // Convert the dictionary to an array of [key, value] pairs
    const entries = Object.entries(dictionary);

    // Filter the array based on the provided condition
    const filteredEntries = entries.filter(
        ([key, item]: [string, IDNameDescriptionItem]) => filterCondition(item)
    );
    // Convert the filtered entries back to a dictionary
    return Object.fromEntries(filteredEntries);
};

export class AutocompleteData {
    label?: string;
    val?: string;
    code?: string;
}
export namespace GlobalMethods {
    export function getDateWithoutTime(date: Date): Date {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();

        // Creating a new Date object with time set to midnight
        return new Date(year, month, day);
    }
}




